var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.crumb.name)?_c('li',{staticClass:"breadcrumb--text breadcrumb--text__link"},[(_vm.crumb.path)?_c('router-link',{attrs:{"to":_vm.crumb.path}},[_vm._v(_vm._s(_vm.crumb.name))]):_vm._e(),(! _vm.crumb.path)?_c('span',[_vm._v(_vm._s(_vm.crumb.name))]):_vm._e()],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }